export type DataPoint = [timestamp: number, value: number];

export const timestampIndex = 0;
export const valueIndex = 1;
